import { useContext } from 'react';

import LocationsAndAssetsSection from '@atom/components/common/workOrderDetail/locationsAndAssetsSection/LocationsAndAssetsSection';
import TaskFields from '@atom/components/common/workOrderDetail/taskFields/TaskFields';
import WorkOrderContext, {
  WorkOrderActionTypes,
} from '@atom/components/workOrderDetail/WorkOrderContext';
import { useNavigation } from '@atom/hooks/useNavigation';
import { Icon } from '@atom/mui';
import { TodayIcon } from '@atom/mui/icons';
import { WorkOrderType } from '@atom/types/work';
import { isTaskDescriptionEnabled } from '@atom/utilities/tenantFeatureUtilities';

import AssetSection from './assetSection/AssetSection';
import FormSection from './formSection/FormSection';
import MaterialSection from './materialSection/MaterialSection';
import TaskHeader from './taskHeader/TaskHeader';
import TeamSection from './teamSection/TeamSection';
import TaskActualCost from './TaskActualCost';
import TaskCompletedDate from './TaskCompletedDate';
import TaskDescription from './TaskDescription';
import TaskDueDate from './TaskDueDate';
import TaskDuration from './TaskDuration';
import TaskEstimatedCost from './TaskEstimatedCost';
import TaskStartDate from './TaskStartDate';
import TaskWorkTime from './TaskWorkTime';

import classes from './taskDetailView.module.css';

const styles = {
  icon: {
    paddingTop: '8px',
  },
};

const TaskDetailView = () => {
  const [{ task: taskParam }] = useNavigation();

  const { workOrderDetail, task, dispatch, refetch } =
    useContext(WorkOrderContext);

  const showAssetSection =
    workOrderDetail.inventoryAssetId &&
    workOrderDetail?.type === WorkOrderType.DEFAULT;
  const showLocationsAndAssetsSection =
    workOrderDetail?.type === WorkOrderType.TASK_ASSETS_AND_LOCATIONS &&
    (task?.locationsEnabled || task?.multiAssetsEnabled);

  return (
    <div className={classes.taskContainer}>
      <TaskHeader />
      <div className={classes.contentContainer}>
        <div className={classes.leftColumn}>
          <div className={classes.timeDetailRow}>
            <Icon style={styles.icon} icon={TodayIcon} />
            <div className={classes.timeRowContainer}>
              <TaskDueDate />
              <TaskStartDate />
              <TaskCompletedDate />
              <TaskWorkTime />
              <TaskDuration />
            </div>
          </div>
          {isTaskDescriptionEnabled && (
            <div className={classes.taskDetailRow}>
              <TaskDescription />
            </div>
          )}
          <TaskFields
            workOrderDetail={workOrderDetail}
            task={task}
            dispatch={dispatch}
            WorkOrderActionTypes={WorkOrderActionTypes}
            refetch={refetch}
          />
          {showAssetSection && <AssetSection />}
          {showLocationsAndAssetsSection && (
            <LocationsAndAssetsSection
              workOrderDetail={workOrderDetail}
              task={task}
              currentTaskId={taskParam}
              refetch={refetch}
            />
          )}
          <FormSection />
        </div>
        <div className={classes.rightColumn}>
          <div className={classes.costContainer}>
            <TaskEstimatedCost />
            <TaskActualCost />
          </div>
          <TeamSection />
          <MaterialSection />
        </div>
      </div>
    </div>
  );
};

export default TaskDetailView;
